import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { CheckCircle, WarningCircle } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";

export default function PaymentReturn() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const sessionId = params.get("session_id");
  const cancelled = params.get("cancelled");
  const [status, setStatus] = useState("checking");
  const [attempts, setAttempts] = useState(0);

  useEffect(() => {
    if (cancelled) { setStatus("cancelled"); return; }
    if (!sessionId) { setStatus("missing"); return; }
    let cancel = false;
    const poll = async (n = 0) => {
      if (cancel) return;
      try {
        const r = await api.get(`/payments/status/${sessionId}`);
        setAttempts(n + 1);
        if (r.data.payment_status === "paid") { setStatus("paid"); return; }
        if (r.data.payment_status === "failed" || r.data.payment_status === "expired") { setStatus("failed"); return; }
        if (n < 8) setTimeout(() => poll(n + 1), 2000);
        else setStatus("pending");
      } catch { setStatus("error"); }
    };
    poll();
    return () => { cancel = true; };
  }, [sessionId, cancelled]);

  return (
    <div className="max-w-lg mx-auto py-10 text-center">
      {status === "checking" && <div><div className="label-caps">Working…</div><h1 className="font-display text-3xl font-extrabold mt-2">Confirming payment</h1><div className="text-slate-600 mt-2">Attempt {attempts}/8</div></div>}
      {status === "paid" && (<div><CheckCircle size={48} weight="fill" className="mx-auto text-emerald-500" /><h1 className="font-display text-3xl font-extrabold mt-3">Payment received</h1><p className="text-slate-600 mt-2">The booking is marked as paid.</p></div>)}
      {(status === "failed" || status === "cancelled") && (<div><WarningCircle size={48} weight="fill" className="mx-auto text-red-500" /><h1 className="font-display text-3xl font-extrabold mt-3">Payment {status}</h1><p className="text-slate-600 mt-2">No charge was made. You can try again.</p></div>)}
      {status === "pending" && (<div><h1 className="font-display text-3xl font-extrabold">Still processing</h1><p className="text-slate-600 mt-2">We'll update the booking shortly.</p></div>)}
      <Button onClick={() => nav("/company/bookings")} className="mt-6 bg-blue-600 hover:bg-blue-700" data-testid="return-to-bookings-btn">Back to bookings</Button>
    </div>
  );
}
